export function waitForElement(document, selector) {
  return new Promise((resolve) => {
    if (!document) {
      return;
    }
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));

        // Stop observing if observer is not null
        if (observer) {
          observer.disconnect();
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Auto disconnect observer after a timeout
    setTimeout(() => {
      if (observer) {
        observer.disconnect();
      }
    }, 2500);
  });
}

export function waitForLastElement(document, selector) {
  return new Promise((resolve) => {
    if ([...document.querySelectorAll(selector)].at(-1)) {
      return resolve([...document.querySelectorAll(selector)].at(-1));
    }

    const observer = new MutationObserver((mutations) => {
      if ([...document.querySelectorAll(selector)].at(-1)) {
        resolve([...document.querySelectorAll(selector)].at(-1));

        // Stop observing if observer is not null
        if (observer) {
          observer.disconnect();
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Auto disconnect observer after a timeout
    setTimeout(() => {
      if (observer) {
        observer.disconnect();
      }
    }, 2500);
  });
}
